import axios from "axios";
import router from '../../../router';

export default {

    async products_search(context, payload){

        const token = context.rootGetters.token;
        console.log('request for products');

        try{
            const responseData = await axios({
                method: 'post',
                url: process.env.VUE_APP_API_ENDPOINT+'products_search',
                data: {
                    term: payload.term,
                    limit: payload.limit,
                    offset: payload.offset,
                    conn_id: payload.conn_id
                },
                mode: 'no-cors',
                headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization' : token
                }
            })

            if(!responseData.data.success){
                context.commit('setRequestError', {message:responseData.data.message} );
            } else {
                context.commit('setRequestError', {message:''} );
                context.commit('setProducts', responseData.data.products);
            }

        } catch(error){
            console.log('error in request')
            context.dispatch('autoLogout', null, { root: true });
            router.replace('/login');
        }

    },

    async product(context, payload){

        const token = context.rootGetters.token;
        console.log('request for product',payload);

        try{
            const responseData = await axios({
                method: 'get',
                url: process.env.VUE_APP_API_ENDPOINT+'product/conn_id/'+payload.master_conn_id+'/pitem_id/'+payload.pitem_id,
                mode: 'no-cors',
                headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization' : token
                }
            })

            return new Promise((resolve, reject) => {
                if(!responseData.data.success){
                    context.commit('setRequestError', {message:responseData.data.message} );
                    reject(responseData.data.message);
                } else {
                    context.commit('setRequestError', {message:''} );
                    context.commit('setProduct', responseData.data.product);
                    resolve(responseData);
                }
            })

        } catch(error){
            console.log('error in request')
            context.dispatch('autoLogout', null, { root: true });
            router.replace('/login');
        }

    }

}